import { useState } from "react";
import { Button } from "@/components/ui";
import { PersonIcon } from "@radix-ui/react-icons";
import { MoreHorizontal } from "lucide-react";
import { useUserStore } from "@/store/UserStore";
import { SystemSettingsDialog } from "@/components/systemsettings/SystemDrawer";

export function UserAuthButton() {
  const { isAuthenticated, username } = useUserStore();
  const displayName = username || "用户";
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const handleLogin = () => {
    window.dispatchEvent(
      new CustomEvent("openAuthModal", { detail: { type: "login" } })
    );
  };
  const systemSettings = () => {
    setIsSettingsOpen(true);
  };
  if (isAuthenticated) {
    return (
      <>
        <div
          className="flex items-center justify-between w-full p-2 rounded-lg hover:bg-accent cursor-pointer transition-colors"
          onClick={systemSettings}
        >
          <div className="flex items-center gap-3">
            <img
              src="/defalutprofile.png"
              alt="User"
              className="w-8 h-8 rounded-full bg-muted"
              onError={(e) => {
                e.currentTarget.src = "/avatar.svg";
              }}
            />
            <span className="text-sm truncate max-w-[120px]">
              {displayName}
            </span>
          </div>
          <MoreHorizontal className="w-5 h-5 text-muted-foreground" />
        </div>
        <SystemSettingsDialog
          open={isSettingsOpen}
          onOpenChange={setIsSettingsOpen}
        />
      </>
    );
  }

  return (
    <div onClick={handleLogin}>
      <Button variant="ghost" size="sm">
        <PersonIcon className="w-4 h-4" />
        <span className=" ml-1">登录</span>
      </Button>
    </div>
  );
}
